import { render, staticRenderFns } from "./Rankingpage.vue?vue&type=template&id=f0a3bb1c&scoped=true&"
import script from "./Rankingpage.vue?vue&type=script&lang=js&"
export * from "./Rankingpage.vue?vue&type=script&lang=js&"
import style0 from "./Rankingpage.vue?vue&type=style&index=0&id=f0a3bb1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a3bb1c",
  null
  
)

export default component.exports